import { Link } from "react-router-dom";
import { AlertTriangle, Car, CheckCircle2, FileText, ListTodo, Receipt, Route } from "lucide-react";

const ICONS = { payment: Receipt, contract: FileText, vehicle: Car, route: Route };
const TONE = { overdue: "bg-red-50 text-red-700 ring-red-200", today: "bg-amber-50 text-amber-800 ring-amber-200", soon: "bg-white text-zinc-700 ring-zinc-200" };
const when = (i) => (i.days == null ? "" : i.days < 0 ? `${-i.days} dni po terminie` : i.days === 0 ? "dziś" : i.days === 1 ? "jutro" : `za ${i.days} dni`);

export const TodayTodo = ({ data }) => {
  if (!data) return null;
  return (
    <section data-testid="today-todo" className="min-w-0 mb-5 border-b-2 border-zinc-200 pb-5">
      <div className="flex items-center gap-3 mb-3">
        <ListTodo className="w-5 h-5 text-brand" />
        <h2 className="font-heading font-bold text-base md:text-lg">Do zrobienia dziś</h2>
        <span data-testid="today-todo-count" className="bg-zinc-900 text-white rounded px-2 py-0.5 text-xs font-mono">{data.count}</span>
      </div>
      {!data.items.length ? (
        <p data-testid="today-todo-empty" className="flex items-center gap-2 text-sm text-emerald-700"><CheckCircle2 className="w-4 h-4" />Wszystko załatwione — nic pilnego.</p>
      ) : (
        <ul className="stagger grid grid-cols-1 gap-2 sm:grid-cols-2 xl:grid-cols-3 min-w-0">
          {data.items.slice(0, 9).map((i, idx) => {
            const Icon = i.severity === "overdue" ? AlertTriangle : ICONS[i.kind] || ListTodo;
            return (
              <li key={`${i.kind}-${idx}`} className="min-w-0">
                <Link to={i.link} data-testid={`today-todo-item-${idx}`} className={`flex items-center gap-3 rounded-xl px-3 py-2.5 ring-1 hover:shadow-md transition-shadow ${TONE[i.severity]}`}>
                  <Icon className="w-4 h-4 shrink-0" />
                  <span className="min-w-0 flex-1"><span className="block text-sm font-semibold truncate">{i.title}</span><span className="block text-[11px] opacity-70 truncate">{i.detail}</span></span>
                  <span className="text-[11px] font-bold whitespace-nowrap">{when(i)}</span>
                </Link>
              </li>
            );
          })}
        </ul>
      )}
      {data.items.length > 9 && <p className="mt-2 text-xs text-zinc-500">{`+ ${data.items.length - 9} więcej`}</p>}
    </section>
  );
};
